export default function BuyerPage() {
  return (
    <div className="container mt-4">
      <h2>Buyer Home</h2>
      <p>Buyer can order food from here.</p>
    </div>
  );
}